import { Navbar, type NavbarProps } from 'shared/Navbar/Navbar'
import { colors } from 'theme'
import { makeStyles } from 'tss-react/mui'

export type PageNavbarProps = Omit<NavbarProps, 'classes' | 'aria-label'> & {
  'aria-label'?: string
}

const useStyles = makeStyles()((_theme) => ({
  root: {
    borderBottom: `1px solid ${colors.backgroundGrey}`,
    marginBottom: '1.5rem',
  },
  list: {
    flexWrap: 'wrap',
  },
  link: {
    fontSize: 18,
  },
}))

export const PageNavbar = ({ links, 'aria-label': ariaLabel }: PageNavbarProps) => {
  const { classes } = useStyles()

  return <Navbar aria-label={ariaLabel || 'Page'} links={links} classes={classes} />
}
